/* eslint-env browser */
import page from 'modules/ab-page-js';
import container from 'modules/section-content';
import React from 'react';
import { render } from 'react-dom';
import SubscriptionCenter from './containers';
import metadata from './data/metadata.json';

/**
 * Routes
 */
export default function register() {
  page('/subscription-center', initial);
}

/**
 * Handle server-side and client-side render differently
 */
function initial(ctx, next) {
  container.render({ metadata });

  ctx.email = getEmailFromURL(); // eslint-disable-line no-param-reassign

  return clientRender(ctx, next);
}

/**
 * Get email from url (?email=pepito@auth0.com)
 */
function getEmailFromURL() {
  return (
    window.location.search
      .substring(1)
      .split('&')
      .filter(item => item.toLowerCase().indexOf('email=') === 0)
      .map(item => item.replace('email=', ''))[0] || ''
  );
}

/**
 * Client render.
 */
function clientRender(ctx, next) {
  render(<SubscriptionCenter email={ctx.email} />, document.getElementById('app'), next);
}



// WEBPACK FOOTER //
// ./src/pages/subscription-center/client.js